angular.module('tgaAdmin').controller('XapiPlayerController', [
  '$scope',
  '$uibModalInstance',
  '$filter',
  'playerService',
  'extra',
  '$log',
  function ($scope, $uibModalInstance, $filter, playerService, extra, $log) {
    $scope.data = angular.copy(extra.player);

    $scope.countupOptions = {
      useEasing: true,
      useGrouping: true,
      separator: ',',
      decimal: ':',
    };

    $scope.viewmodel = {
      sessions: [],
      game: extra.game,
      statements: extra.statements,
    };

    $scope.initialize = function () {
      $scope.loading = true;

      playerService
        .getPlayer(extra.player.id, extra.game_id, extra.startDate.toISOString(true), extra.endDate.toISOString(true))
        .then((data) => {
          $log.log('player', data);
          const avg_time = $filter('formatDuration')(data.average_time).split(':');
          $scope.viewmodel.avgTime = parseFloat(`${avg_time[1]}.${avg_time[2]}`);
          $scope.viewmodel.high_score = data.high_score;
          $scope.viewmodel.total_sessions = data.total_sessions;
          // $scope.viewmodel.sessions = data.sessions;
          $scope.loading = false;

          $log.debug('statements', $scope.viewmodel.statements);
          const levels = {};
          const sessions = {};
          $scope.viewmodel.statements.forEach((s) => {
            if (s.verb.id === 'http://adlnet.gov/expapi/verbs/entered') {
              levels[s.object.id] = s.object.definition.name['en-US'].replace(/\D/g, '');
            }
          });

          $scope.viewmodel.statements
            .filter(
              (s) => s?.context?.extensions && s.context.extensions[`${$scope.viewmodel.game.xapi_activity_id}/sessionID`],
            )
            .forEach((s) => {
              const sessionId = s.context.extensions[`${$scope.viewmodel.game.xapi_activity_id}/sessionID`];
              sessions[sessionId] = sessions[sessionId] || {
                date: s.timestamp,
                time: null,
                level: null,
                levels: {},
                total_items: 0,
                total_clues: 0,
                complete: false,
              };

              // Entered level
              if (s.verb.id === 'http://adlnet.gov/expapi/verbs/entered') {
                const level = parseInt(s.object.definition.name['en-US'].replace(/\D/g, ''), 10);
                const levelId = s.object.id;
                sessions[sessionId].levels[levelId] = sessions[sessionId].levels[levelId] || {
                  name: levels[levelId],
                  time: null,
                  items: new Set(),
                  clues: new Set(),
                };
                sessions[sessionId].level = sessions[sessionId].level < level ? level : sessions[sessionId].level;
              }

              // Exited level
              if (s.verb.id === 'http://adlnet.gov/expapi/verbs/exited') {
                const levelId = s.object.id;
                sessions[sessionId].levels[levelId] = sessions[sessionId].levels[levelId] || {
                  name: levels[levelId],
                  time: null,
                  items: new Set(),
                  clues: new Set(),
                };
                sessions[sessionId].levels[levelId].time = moment.duration(s?.result?.duration);
              }

              // Item clicked
              if (s.verb.id === 'http://adlnet.gov/expapi/verbs/reviewed') {
                const item = s.object.definition.name['en-US'];
                const levelId = s.context.contextActivities.parent[0].id;
                sessions[sessionId].levels[levelId] = sessions[sessionId].levels[levelId] || {
                  name: levels[levelId],
                  time: null,
                  items: new Set(),
                  clues: new Set(),
                };
                sessions[sessionId].levels[levelId].items.add(item);
                sessions[sessionId].total_items = Object.values(sessions[sessionId].levels)
                  .map((x) => x.items.size)
                  .reduce((a, b) => a + b, 0);
              }

              // Clue used
              if (s.verb.id === 'http://adlnet.gov/expapi/verbs/used') {
                const clue = s.object.definition.name['en-US'];
                const levelId = s.context.contextActivities.parent[0].id;
                sessions[sessionId].levels[levelId] = sessions[sessionId].levels[levelId] || {
                  name: levels[levelId],
                  time: null,
                  items: new Set(),
                  clues: new Set(),
                };
                sessions[sessionId].levels[levelId].clues.add(clue);
                sessions[sessionId].total_clues = Object.values(sessions[sessionId].levels)
                  .map((x) => x.clues.size)
                  .reduce((a, b) => a + b, 0);
              }

              if (s.verb.id === 'http://adlnet.gov/expapi/verbs/completed') {
                sessions[sessionId].complete = true;
                sessions[sessionId].time = moment.duration(s?.result?.duration);
              }
            });

          const sessionsArr = Object.values(sessions);
          let totalLevelsPlayed = 0;
          sessionsArr.forEach((s) => {
            s.levels = Object.values(s.levels);
            totalLevelsPlayed += s.levels.length;
          });
          $scope.viewmodel.avg_level = sessionsArr.map((s) => s.level).reduce((a, b) => a + b, 0) / sessionsArr.length;
          $scope.viewmodel.avg_items = sessionsArr.map((s) => s.total_items).reduce((a, b) => a + b, 0) / totalLevelsPlayed;
          $scope.viewmodel.avg_clues = sessionsArr.map((s) => s.total_clues).reduce((a, b) => a + b, 0) / totalLevelsPlayed;
          $log.debug('levels', levels);
          $log.debug('sessions', sessions);
          $scope.viewmodel.sessions = sessionsArr;
        });
    };

    $scope.actions = {
      ok(data) {
        $uibModalInstance.close(data);
      },
      cancel(data) {
        $uibModalInstance.dismiss(data);
      },
    };

    $scope.initialize();
  },
]);
